import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmInputInvoice} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';
import './InvoiceStatusHistoryCard.scss';

export function InvoiceStatusHistoryCard(props: {
  invoice?: IFarmInputInvoice;
  isLoading?: boolean;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.invoice) return null;
  const {invoice} = props;

  return (
    <Card className="invoice-status-history-card" variant="outlined">
      <Box className="row header">
        <Box className="index-container">
          <Typography className="bold" variant="body2">
            #
          </Typography>
        </Box>
        <Box className="status-container">
          <Typography className="bold" variant="body2">
            Status
          </Typography>
        </Box>
        <Box className="description-container">
          <Typography className="bold" variant="body2">
            Description
          </Typography>
        </Box>
      </Box>
      {invoice.orderStatus.map((step) => {
        const isCurrent =
          step.status === invoice.currOrderStatus.status &&
          step.index === invoice.currOrderStatus.index;
        return (
          <div key={step.index}>
            <Divider />
            <Box className={`row ${isCurrent ? 'current' : ''}`}>
              <Box className="index-container">
                <Typography
                  variant="body2"
                  color={isCurrent ? 'textPrimary' : 'textSecondary'}
                >
                  {step.index + 1}
                </Typography>
              </Box>
              <Box className="status-container">
                <Typography
                  variant="body2"
                  color={isCurrent ? 'textPrimary' : 'textSecondary'}
                >
                  {step.status}
                </Typography>
              </Box>
              <Box className="description-container">
                <Typography
                  variant="body2"
                  color={isCurrent ? 'textPrimary' : 'textSecondary'}
                >
                  {step.description}
                </Typography>
              </Box>
            </Box>
          </div>
        );
      })}
    </Card>
  );
}
